export default "__VITE_ASSET__A2m1iVgw__"